<ng-container *appTranslate="let t">
  @if (showOutgoingTab || showIncomingTab) {
    <new-ui-dashboard-card>
      <ng-template #header>
        <new-ui-dashboard-card-header [title]="t('dashboard.talentPoolSharings.title')" />
      </ng-template>

      @defer (when sharings()) {
        <p-tabs class="min-w-fit" value="0">
          <p-tablist class="min-w-fit">
            <p-tab value="0">{{ t("dashboard.talentPoolSharings.myPool.title") }}</p-tab>
            <p-tab value="1">{{ t("dashboard.talentPoolSharings.sharedToMe.title") }}</p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="0">
              @if (sharings().myPool?.length > 0) {
                <new-ui-dashboard-list [values]="sharings().myPool" />
              } @else {
                <ui-emptystate
                  class="py-[3%]"
                  image="/assets/layout/images/new-ui/search.png"
                  [caption]="t('dashboard.talentPoolSharings.myPool.emptyState.title')"
                  [description]="t('dashboard.talentPoolSharings.myPool.emptyState.description')"
                />
              }
            </p-tabpanel>
            <p-tabpanel value="1">
              @if (sharings().sharedToMe?.length > 0) {
                <new-ui-dashboard-list [values]="sharings().sharedToMe" />
              } @else {
                <ui-emptystate
                  class="py-[3%]"
                  image="/assets/layout/images/new-ui/search.png"
                  [caption]="t('dashboard.talentPoolSharings.sharedToMe.emptyState.title')"
                  [description]="t('dashboard.talentPoolSharings.sharedToMe.emptyState.description')"
                />
              }
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      } @placeholder {
        <ul class="col gap-4 p-0 pr-2">
          @for (item of [1, 2, 3]; track item) {
            <li class="flex flex-col mobile:flex-row gap-4 p-2 border border-surface-border rounded-lg shadow-sm">
              <div class="basis-1/2 row gap-2">
                <p-skeleton shape="circle" size="1.25rem" />
                <p-skeleton class="h-5 w-40" />
              </div>
              <div class="basis-1/2 row gap-2">
                <p-skeleton shape="circle" size="1rem" />
                <p-skeleton class="h-5 w-24" />
              </div>
            </li>
          }
        </ul>
      }
    </new-ui-dashboard-card>
  }
</ng-container>
